<div class="errorModal errorModalWrapper">
  <div class="closeModal" (click)="closeModal();"></div>
  <img alt="error" class="imageError" src="../../assets/images/newCircleIcons/error.svg" />
  <h1>{{ 'dashboard.addFunds.error' | translate }}</h1>
  <div class="errorMessageContainer">
    <span *ngIf="errorID === 10426">{{ 'errors.10426' | translate }}</span>
    <span *ngIf="errorID === 1042">{{ 'errors.1042a' | translate }}<br></span>
    <span *ngIf="errorID === 1042">{{ 'errors.1042b' | translate }}</span>
    <span *ngIf="errorID === 0">{{ 'scratchcards.error000' | translate }}</span>
  </div>
  <div class="przycisk big orange closeModalButton" (click)="closeModal();">Ok</div>
</div>
